import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { UsersLogsComponent } from "../../components/logs"

export const LogsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <UsersLogsComponent />
    </DefaultPageComp>
  </>
}